import { BlobRef } from "@atproto/api";
import { DidDocument } from "@atproto/identity/dist/types";

export function syncResolveBlob(blob: BlobRef, didDoc: DidDocument): string {
  const pds = didDoc.service?.find((v,_,__) => v.type == "AtprotoPersonalDataServer")?.serviceEndpoint;
  return `${pds}/xrpc/com.atproto.sync.getBlob?did=${encodeURIComponent(didDoc.id)}&cid=${encodeURIComponent(blob.ref.toString())}`;
}
